import * as React from 'react';
import DataTable from 'react-data-table-component';

const columns = [
  {
    selector: row => row['plant_date'] || "NA",
    name: 'Plant Date',
    sortable: true,
    grow: 3,
  },
  {
    selector: row => row['harvest_date'] || "NA",
    name: 'Harvest Date',
    sortable: true,
    grow: 3,
  },
  {
    selector: row => row['total'] || "NA",
    name: 'kg',
    sortable: true,
    grow: 2,
  },
  {
    selector: row => row['greenhouse_id'] || "NA",
    name: 'Greenhouse',
    sortable: true,
    grow: 4,
  },
  {
    selector: row => row['Plowing'] || "NA",
    name: 'Planting',
  },
  {
    name: 'Argo-Chem 1',
    selector: row => row['Apply Agro-Chemical 1'] || "NA",
    grow: 3,
  },
  {
    name: 'Argo-Chem 2',
    selector: row => row['Apply Agro-Chemical 2'] || "NA",
    grow: 3,
  },
  {
    name: 'Argo-Chem 3',
    selector: row => row['Apply Agro-Chemical 3'] || "NA",
    grow: 3,
  },
  {
    name: 'Argo-Chem 4',
    selector: row => row['Apply Agro-Chemical 4'] || "NA",
    grow: 3,
  },
  {
    selector: row => row['Fertilizing 1'] || "NA",
    name: 'Fertilizing 1',
  },
    {
    selector: row => row['Fertilizing 2'] || "NA",
    name: 'Fertilizing 2',
  },
  {
    name: 'Fertilizing 3',
    selector: row => row['Fertilizing 3'] || "NA",
    grow: 3,
  },
  {
    name: 'Fertilizing 4',
    selector: row => row['Fertilizing 4'] || "NA",
    grow: 3,
  },
    {
    selector: row => row['Harvest'] || "NA",
    name: 'Harvest',
  },
];

const pagination = true
const paginationPage = 10
const paginationRowsPerPageOptions = [10]

const TopTenYieldTable = (rows) => {
  return (
    <div style={{ height: 400, width: '100%' }}>
      <DataTable
        title = "Top 10 tasks with highest yield with Cultivation Model vs Actual Operation (Day)"
        columns={columns}
        data={rows.data}
        pagination={pagination}
        paginationPerPage={paginationPage}
        paginationRowsPerPageOptions={paginationRowsPerPageOptions}
      />
    </div>
  )
}

export default TopTenYieldTable